module.exports = __webpack_public_path__ + "img/the_room_of_requirement.8a438f87.jpg";